import React, { useEffect, useState } from 'react';
import { contentList } from "../../../Data/Data";
import ListContent from "./SubScreenList/ListContent";
import Pagination from './SubScreenList/Pagination';
import TitleListContent from './SubScreenList/TitleListContent';
import ItemFilter from './SubScreenList/ItemFilter';
import DateSelect from './SubScreenList/DateSelect';

function ScreenListContent({ chooseContent, contentForDelete, contentForEdit }) {

    const [array, setArray] = useState([])
    const [channelName, setChannelName] = useState("")
    const [adminName, setAdminName] = useState("")
    const [text, setText] = useState("")

    useEffect(() => {
        setArray(contentList
            .filter(value => {
                if (channelName === "") {
                    return value;
                }
                else if (value.channelName.toLowerCase().includes(channelName.toLowerCase())) {
                    return value;
                }
            })
            .filter(value => {
                if (adminName === "") {
                    return value;
                }
                else if (value.Admin.toLowerCase().includes(adminName.toLowerCase())) {
                    return value;
                }
            })
            .filter(value => {
                if (text === "") {
                    return value;
                }
                else if (value.text.toLowerCase().includes(text.toLowerCase())) {
                    return value;
                }
            })
        )
    }, [channelName, adminName, text])

    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(12);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = array.slice(indexOfFirstPost, indexOfLastPost)

    return (
        <div className="m-4 p-2 border border-slate-200 rounded-lg h85 flex flex-col items-end">
            <div className='flex flex-row-reverse items-center justify-between bg-slate-100 w-full p-2 rounded shadow mb-2'>
                <div className='flex items-center'>
                    <p className='t-purpleDark text-xs'>فیلتر</p>
                    <img
                        src="/image/icon/filter.png"
                        className="w-7 mx-2 filterIcon"
                    />
                </div>
                <ItemFilter text=" : نام کانال" value={channelName} setValue={setChannelName} />
                <ItemFilter text=" : نام ادمین" value={adminName} setValue={setAdminName} />
                <ItemFilter text=" : متن " value={text} setValue={setText} />
                <DateSelect />
            </div>
            <TitleListContent array={array} />
            <ListContent
                list={currentPosts}
                chooseContent={chooseContent}
                contentForDelete={contentForDelete}
                contentForEdit={contentForEdit}
            />
            {array.length >= 12 ?
                <Pagination
                    postsPerPage={postsPerPage}
                    totalPosts={array.length}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                :
                null
            }
        </div>
    )
}
export default ScreenListContent;